module.exports = __webpack_public_path__ + "static/media/0029.804e6fbe.svg";